import {
  CreateParkPromoRequest,
  GetPromoStatisticsRequest,
  GetPromoStatisticsResponse,
  PromoStatistics,
  Promotion,
  UpdateParkPromoRequest,
} from 'rikroot-types/parksmanagement/promo.pb'
import { TPromoStatisticsRequest } from '../models/PromoStatisticsRequest.model'
import { HttpClient } from '@/core/utils/httpClient'

export class PromoRepository extends HttpClient {
  resource = '/park_management/promo'

  async getPromoSettings(): Promise<Promotion[]> {
    const response = await this.get(`${this.resource}`)
    return response?.promotions ?? []
  }

  async createPromoSetting(promoSetting: CreateParkPromoRequest): Promise<Promotion> {
    const response = await this.post(`${this.resource}`, promoSetting)
    return response?.promotion ?? {}
  }

  async updatePromoSetting(promoSetting: UpdateParkPromoRequest): Promise<Promotion> {
    const response = await this.put(`${this.resource}`, promoSetting)
    return response?.promotion ?? {}
  }

  async deletePromoSetting(id: string): Promise<void> {
    return await this.delete(`${this.resource}?id=${id}`)
  }

  async getPromoStatistics(req: TPromoStatisticsRequest): Promise<GetPromoStatisticsResponse> {
    const { id, ...params } = req
    return await this.get(`/park_management/promo/${id}/statistics`, { params })
  }
}
